import axios from 'axios'
import store from './store'
import { router } from './router';
//import { getToken } from '@/utils/auth'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API, // api 的 base_url
  //withCredentials: true, // 跨域请求时发送 cookies
  //timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   console.log(store.getters.token);
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['token'] = store.getters.token
    // }
    // eslint-disable-next-line no-console
    config.headers={
      //'Content-Type':'application/x-www-form-urlencoded',
     // 'token' :store.getters.token
    }
    return config
  },
  error => {
    // Do something with request error
   
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    //console.log('res',res);
    if (res.code == 200) {
      return Promise.resolve(res.body)
    } else if(res.code == 401){
      // store.commit("removeToken");
      // router.push('/login-');
    }
      return Promise.reject(res)
    //return res;
  },
  error => {
    //Toast("接口错误");
    // eslint-disable-next-line no-console
    console.log('err', error) // for debug
    return Promise.reject(error)
  }
)

export default service